import { Chip, Link, Stack, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api/client";
import { LoadingState } from "../components";
import { formatDate } from "../i18n/format";
import { Markdown } from "../marketing/Markdown";
import { Section, Seo } from "../marketing/MarketingLayout";

type Note = { id: string; version: string; title: string; body_markdown: string; tags: string[]; published_at: string };

export function useReleaseNotes() {
  return useQuery({ queryKey: ["changelog"], queryFn: async () => ((await api.GET("/api/v1/website/changelog/")).data ?? []) as unknown as Note[] });
}

export function ChangelogPage() {
  const notes = useReleaseNotes();
  return (
    <Section>
      <Seo title="Changelog" description="What's new in CloudForge ERM." />
      <Stack direction="row" justifyContent="space-between" alignItems="baseline"><Typography variant="h1" sx={{ fontSize: "2.4rem" }}>Changelog</Typography><Link href="/api/v1/website/changelog/feed/" target="_blank" rel="noopener">RSS</Link></Stack>
      {notes.isLoading && <LoadingState />}
      <Stack spacing={4} sx={{ mt: 3 }}>
        {notes.data?.map((n) => (
          <div key={n.id} id={n.id}>
            <Stack direction="row" spacing={1} alignItems="center"><Typography variant="h5">{n.title}</Typography>{n.version && <Chip size="small" label={`v${n.version}`} />}</Stack>
            <Typography variant="caption" color="text.secondary">{formatDate(n.published_at)} {n.tags.map((t) => <Chip key={t} size="small" variant="outlined" label={t} sx={{ ml: 0.5 }} />)}</Typography>
            <Markdown source={n.body_markdown} />
          </div>
        ))}
      </Stack>
    </Section>
  );
}
